// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Sn","breadcrumbItem":"Tn"};